import {capitalize, forEach, map, max, maxBy, minBy, transform, truncate} from 'lodash';

export const getFittedTickLabels = ({
  textLength, scaleFn, labels, labelFormatFn = (value) => value, labelPadding = 4, widthMax,
}) => {
  const formattedLabels = transform(labels, (result, group) => {
    result[group] = labelFormatFn(group);
  }, {});

  if (!textLength || !scaleFn) return formattedLabels;

  const showTicks = new Array(labels.length);
  let maxCharacters = -1;
  let widthBetweenTicks = 0;
  forEach(labels, (group, index) => {
    const label = formattedLabels[group];
    const prevX = index - 1 < 0 ? 0 : scaleFn(labels[index - 1]);
    const nextX = index + 1 === labels.length ? widthMax : scaleFn(labels[index + 1]);
    const width = Math.ceil((nextX - prevX) / 2);
    showTicks[index] = (textLength[label] + labelPadding <= width);
    if (showTicks[index] && label.length > maxCharacters) {
      maxCharacters = label.length;
    }
    if (widthBetweenTicks < width) widthBetweenTicks = width;
  });

  return transform(labels, (result, label, index) => {
    if (showTicks[index]) {
      result[label] = labelFormatFn(label);
    } else {
      result[label] = truncate(labelFormatFn(label), {
        length: max([maxCharacters, Math.floor(widthBetweenTicks / 5.5)])
      });
    }
  }, {});
};

export const extent = (iterable, accessor) => {
  return [
    minBy(iterable, accessor)?.[accessor] ?? 0,
    maxBy(iterable, accessor)?.[accessor] ?? 0
  ];
};

export const makePrintable = (key) => {
  return map(`${key}`.split('_'), capitalize).join(' ');
};
